import classNames from "classnames";
import React, { PropsWithChildren, ReactElement } from "react";
import { withDefault } from "../../utils/withDefault";

export interface AppCardProps
  extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  color?: "primary" | "success" | "danger" | "black" | "white" | "teal" | "warning";
  variant?: "filled" | "outline" | "soft";
  cardRef?: React.RefObject<HTMLDivElement>;
}

export function AppCard(props: PropsWithChildren<AppCardProps>): ReactElement {
  const { cardRef, children, ...rest } = props;

  return (
    <div
      {...rest}
      data-color={withDefault(props.color, "white")}
      data-variant={withDefault(props.variant, "filled")}
      className={classNames("AppCard", props.className)}
      ref={cardRef}
    >
      {props.children}
    </div>
  );
}

export interface AppCardHeaderProps
  extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  borderless?: boolean;
}

export function AppCardHeader(props: PropsWithChildren<AppCardHeaderProps>): ReactElement {
  const { borderless, ...rest } = props;

  return (
    <div
      {...rest}
      className={classNames("AppCardHeader", props.className, {
        Borderless: props.borderless === true,
      })}
    >
      {props.children}
    </div>
  );
}

export function AppCardIcon(
  props: PropsWithChildren<
    React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>
  >
): ReactElement {
  const { children, ...rest } = props;
  return (
    <div {...rest} className={classNames("AppCardIcon", rest.className)}>
      {children}
    </div>
  );
}

export function AppCardTitle(
  props: PropsWithChildren<
    React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>
  >
): ReactElement {
  const { children, ...rest } = props;
  return (
    <div {...rest} className={classNames("AppCardTitle", rest.className)}>
      {children}
    </div>
  );
}

export function AppCardSubtitle(
  props: PropsWithChildren<
    React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>
  >
): ReactElement {
  const { children, ...rest } = props;
  return (
    <div {...rest} className={classNames("AppCardSubtitle", rest.className)}>
      {children}
    </div>
  );
}

export function AppCardContent(
  props: PropsWithChildren<
    React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>
  >
): ReactElement {
  const { children, ...rest } = props;
  return (
    <div {...rest} className={classNames("AppCardContent", rest.className)}>
      {children}
    </div>
  );
}

export function AppCardFooter(
  props: PropsWithChildren<
    React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>
  >
): ReactElement {
  const { children, ...rest } = props;
  return (
    <div {...rest} className={classNames("AppCardFooter", rest.className)}>
      {children}
    </div>
  );
}
